export const counsel = [
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 ASPLIN ORDER-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2021_12_01 ASPLIN ORDER-2.jpg"
  }
];
